import { DataBean } from "../DataBean";

export class ProductionOrderEvent extends DataBean {

  public async getProductionOrderEventCatalog(idProductionOrder: number, productionOrderDate: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderEventCatalog_Number_java.util.Date", [idProductionOrder, productionOrderDate]);
  }

}
